import React from 'react'; 
import { Suspense, ComponentType } from 'react'; 
import Loader from '../Loader';

// This is a higher-order component (HOC) that accepts a component and wraps it in Suspense
const Loadable = <P extends object>(Component: ComponentType<P>): React.FC<P> => {
    return (props: P) => ( // The HOC returns a functional component that accepts props of type 'P'
        <Suspense fallback={<Loader />}> {/* Suspense is used to show a fallback UI (in this case, the 'Loader' component) while the wrapped component is loading */}
            <Component {...props} /> {/* The wrapped component is rendered with the passed props */}
        </Suspense>
    );
};

export default Loadable;
